import { factory, sequence } from 'stahlwerk';

export const createGroup = factory({
  id: sequence(),
  crewId: sequence(),
  name: sequence((id) => `Group ${id}`),
  disabled: false,
  disabledAt: null,
});
